import Vue from 'vue'
import VueRouter from 'vue-router'
// import Login from "../views/Login.vue";
import Main from "../views/Main.vue";
import NotFound from "../views/Error/NotFound.vue";
import HomePage from "../views/home/HomePage.vue";
// 产品页
import AllProducts from '../components/product/Products.vue'
import ProductDetails from '../components/product/ProductDetails.vue'
// 新闻
import News from '../components/news/News.vue'
import NewsCom from '../components/news/NewsCom.vue'
import NewsIns from '../components/news/NewsIns.vue'
import SLong from '../components/news/SLong.vue'
import NewsDetails from '../components/news/NewsDetails.vue'
import NewsTec from '../components/news/NewsTec.vue'
// VIP中心
import VIPCenter from '../components/vipCenter/VIPCenter.vue'
import JoinVIP from '../components/vipCenter/JoinVIP.vue'
import Favorite from '../components/vipCenter/Favorite.vue'
import NewProduct from '../components/vipCenter/NewProduct.vue'
import ProjectProgress from '../components/vipCenter/ProjectProgress.vue'
import OrderProgress from '../components/vipCenter/OrderProgress.vue'
// 下载页
import Download from '../components/download/Download.vue'
import ProductBrochure from '../components/download/ProductBrochure.vue'
import DownloadDetails from '../components/download/DownloadDetails.vue'
import ProductManual from '../components/download/ProductManual.vue'
import OrderInquiry from '../components/download/OrderInquiry.vue'
import Certificate from '../components/download/Certificate.vue'
// 关于我们
import AboutUs from '../components/aboutUs/AboutUs.vue'
import Sanmak from '../components/aboutUs/Sanmak.vue'
import Contact from '../components/aboutUs/Contact.vue'
import Leave from '../components/aboutUs/Leave.vue'
import Vlog from '../components/aboutUs/Vlog.vue'
import VlogDetail from '../components/aboutUs/VlogDetail.vue'
import SanmakView from '../components/aboutUs/SanmakView.vue'

// 后台
import BackLogin from '@/views/Backend/BackLogin.vue'
import BackIndex from '@/views/Backend/BackIndex.vue'
import BackUser from '@/views/Backend/BackUser.vue'
import BackHome from '@/views/Backend/BackHome.vue'
import BackHomeVideo from '@/views/Backend/BackHomeVideo.vue'
// import subTest11 from '@/views/Backend/subTest11.vue'
// import subTest12 from '@/views/Backend/subTest12.vue'
import BackRole from '@/views/Backend/BackRole.vue'
import BackTecSup from '@/views/Backend/BackTecSup.vue'
import BackProduct from '@/views/Backend/BackProduct.vue'
import BackProductSort from '@/views/Backend/BackProductSort.vue'
import BackComNews from '@/views/Backend/BackComNews.vue'
import BackInsNews from '@/views/Backend/BackInsNews.vue'
import BackProductType from '@/views/Backend/BackProductType.vue'
import BackProductMainCode from '@/views/Backend/BackProductMainCode.vue'
import BackVlogType from '@/views/Backend/BackVlogType.vue'
import BackVlog from '@/views/Backend/BackVlog.vue'
import BackAboutUs from '@/views/Backend/BackAboutUs.vue'
import BackCertificate from '@/views/Backend/BackCertificate.vue'
import BackAlbum from '@/views/Backend/BackAlbum.vue'
import BackHandBook from '@/views/Backend/BackHandBook.vue'
import vueEditor from '@/views/Backend/vueEditor.vue'
import BackAboutRecruit from '@/views/Backend/BackAboutRecruit.vue'
Vue.use(VueRouter)

// const routes = [
//     {
//         path: '/',
//         component: Main,
//         redirect: '/Home',
//         name: 'Home',
//         children: [
//             { path: 'Home', name: 'Home', components: { default: HomePage, login: Login } },

//             { path: 'products/:category', name: 'products', component: AllProducts, },
//             { path: 'products/:category/:productsName', name: 'products', component: ProductDetails, },
//             { path: 'news/:newsName', name: 'news', component: News },
//             { path: 'slong', name: 'slong', component: SLong },

//             { path: 'news/:newsName/:category', name: 'news', component: NewsDetails },
//             {
//                 path: 'vipCenter',
//                 name: 'vipCenter',
//                 component: VIPCenter,
//                 children: [
//                     { path: 'JoinVIP', name: 'vipCenter', component: JoinVIP },
//                     { path: 'ProjectProgress', name: 'vipCenter', component: ProjectProgress },
//                     { path: 'OrderProgress', name: 'vipCenter', component: OrderProgress },
//                     { path: 'Favorite', name: 'vipCenter', component: Favorite },
//                     { path: 'NewProduct', name: 'vipCenter', component: NewProduct },
//                 ]
//             },
//             {
//                 path: 'download',
//                 name: 'download',
//                 component: Download,
//                 children: [
//                     { path: 'ProductBrochure', name: 'download', component: ProductBrochure },
//                     { path: 'DownloadDetails', name: 'download', component: DownloadDetails },
//                     { path: 'ProductManual', name: 'download', component: ProductManual },
//                     { path: 'OrderInquiry', name: 'download', component: OrderInquiry },
//                     { path: 'Certificate', name: 'download', component: Certificate },
//                 ]
//             },
//             {
//                 path: 'aboutUs',
//                 name: 'aboutUs',
//                 component: AboutUs,
//                 children: [
//                     { path: 'Sanmak', name: 'aboutUs', component: Sanmak },
//                     { path: 'Contact', name: 'aboutUs', component: Contact },
//                     { path: 'Leave', name: 'aboutUs', component: Leave },
//                     { path: 'Vlog', name: 'aboutUs', component: Vlog },
//                 ]
//             },
//         ],
//     }, {
//         path: '/NotFound',
//         name: 'NotFound',
//         component: NotFound,
//     },
//     {
//         path: '/BackLogin',
//         name: 'BackLogin',
//         component: BackLogin,
//     },
//     {
//         path: '/BackIndex',
//         name: 'BackIndex',
//         component: BackIndex,
//         meta: {
//             title: '首页',
//             requireAuth: true // 标识该路由是否需要登录
//         },
//         children: [{ path: 'BackUser', name: 'BackUser', components: BackUser },{ path: 'test1', name: 'test1', components: test1}],
//     },
//     { path: '/test2', component: test2 },
//     // { path: '*', redirect: '/HomePage' },
// ]
const routes = [{
  path: '/main'
  , component: Main
  , children: [{
    path: '/home', name: 'Home', component: HomePage
  },
  {
    path: 'products/:category?', name: 'products', component: AllProducts,
  },
  { path: 'products/:category/:productsName', name: 'product', component: ProductDetails },
  // { path: 'news/:newsName', name: 'news', component: News },
  // { path: 'slong', name: 'slong', component: SLong},
  {
    path: 'news',
    name: 'news',
    component: News,
    children: [
      { path: 'NewsCom', name: 'news', component: NewsCom },
      { path: 'NewsIns', name: 'news', component: NewsIns },
      { path: 'SLong', name: 'news', component: SLong },
      { path: 'NewsTec', name: 'news', component: NewsTec },
    ]
  },
  { path: 'news/:newsName/:category/:id', name: 'news', component: NewsDetails },
  {
    path: 'vipCenter',
    name: 'vipCenter',
    component: VIPCenter,
    children: [
      { path: 'JoinVIP', name: 'vipCenter', component: JoinVIP },
      { path: 'ProjectProgress', name: 'vipCenter', component: ProjectProgress },
      { path: 'OrderProgress', name: 'vipCenter', component: OrderProgress },
      { path: 'Favorite', name: 'vipCenter', component: Favorite },
      { path: 'NewProduct', name: 'vipCenter', component: NewProduct },
      { path: 'Certificate', name: 'vipCenter', component: Certificate },
    ]
  },
  {
    path: 'download',
    name: 'download',
    component: Download,
    children: [
      { path: 'ProductBrochure', name: 'download', component: ProductBrochure },
      { path: 'DownloadDetails', name: 'download', component: DownloadDetails },
      { path: 'ProductManual', name: 'download', component: ProductManual },
      { path: 'OrderInquiry', name: 'download', component: OrderInquiry },
    ]
  },
  {
    path: 'aboutUs',
    name: 'aboutUs',
    component: AboutUs,
    children: [
      { path: 'Sanmak/:id?', name: 'aboutUs', component: Sanmak },
      { path: 'Contact', name: 'aboutUs', component: Contact },
      { path: 'Leave', name: 'aboutUs', component: Leave },
      { path: 'Vlog', name: 'aboutUs', component: Vlog },
      { path: 'SanmakView', name: 'SanmakView', component: SanmakView },
    ]
  },
  { path: 'AboutUs/:VlogName/:id?', name: 'AboutUs', component: VlogDetail },
  {
    path: '/NotFound',
    name: 'NotFound',
    component: NotFound,
  },
  ]
}
  , {
  path: '/BackIndex', component: BackIndex
  , children: [{ path: 'BackUser', component: BackUser, },
  { path: 'BackHome', component: BackHome, },
  { path: 'BackHomeVideo', component: BackHomeVideo, },
  { path: 'BackRole', component: BackRole, },
  { path: 'BackTecSup', component: BackTecSup, },
  { path: 'BackProduct', component: BackProduct, },
  { path: 'BackProductSort', component: BackProductSort, },
  { path: 'BackComNews', component: BackComNews, },
  { path: 'BackInsNews', component: BackInsNews, },
  { path: 'BackProductType', component: BackProductType, },
  { path: 'BackProductMainCode', component: BackProductMainCode, },
  { path: 'BackVlog', component: BackVlog, },
  { path: 'BackVlogType', component: BackVlogType, },
  { path: 'BackAboutUs', component: BackAboutUs, },
  { path: 'BackCertificate', component: BackCertificate, },
  { path: 'BackAlbum', component: BackAlbum, },
  { path: 'BackHandBook', component: BackHandBook, },
  { path: 'vueEditor', component: vueEditor, },
  { path: 'BackAboutRecruit', component: BackAboutRecruit, },
  ]
}
  , { path: '/BackLogin', component: BackLogin, }
  , { path: '*', redirect: '/home' }]
const router = new VueRouter({
  mode: 'hash', // 使用 History 模式
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果有保存的滚动位置（比如浏览器前进后退）
      return savedPosition;
    } else {
      // 没有保存位置时保持当前滚动位置（或滚动到顶部）
      return { x: 0, y: 0 };
    }
  },
})
// 路由守卫
// router.beforeEach((to, from, next) => {
//     const hasToken = localStorage.getItem('token')

//     if (to.path === '/BackLogin') {
//       if (hasToken) {
//         next({ path: '/backIndex' })
//       } else {
//         next()
//       }
//     } else {
//       if (!hasToken) {
//         next(`/BackLogin?redirect=${to.path}`)
//       } else {
//         next()
//       }
//     }
//   })


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth)) {
    let token = localStorage.getItem('token');

    if (token) {
      next();
    } else {
      next({
        path: '/BackLogin'
      });
    }
  } else {
    next();
  }
});

export default router